import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontFamily: "Source Sans Pro, sans-serif",
  }
}));

export default useStyles;
